import { ReactNode } from 'react'

import { useActionless, useAppSelector } from 'app-redux/hooks'
import { SET_ACTIVE_STATE } from 'app-redux/active/actions/types'
import { SET_CACHEABLES_STATE } from 'app-redux/cacheables/actions/types'

import GlobalOverlayStack from 'components/elements/Overlay/GlobalOverlayStack'
import ImageSizeControls from 'components/collectionV2/views/Image/ImageSizeControls'
import { InDeckCardGrid } from 'components/cardSearchPanel/cardLayouts/cardResultsGrid'

import styles from './cardComparisonOverlay.module.scss'

const CardComparisonOverlay = () => {
  const searchImageSize = useAppSelector(state => state.cacheables.searchImageSize)
  const multiSelectedIds = useAppSelector(state => state.active.multiSelectedIds)
  const comparingCards = useAppSelector(state => state.active.compareCardsOverlay)

  const [setActiveState, setCachablesState] = useActionless(SET_ACTIVE_STATE, SET_CACHEABLES_STATE)

  const handleClose = () => {
    setActiveState({ compareCardsOverlay: false })
  }

  return (
    <GlobalOverlayStack className={styles.container} open={!!comparingCards} onClose={handleClose}>
      <div className={styles.header}>
        <h2>Selected Cards</h2>
        <ImageSizeControls
          className={styles.imageSizeControls}
          imageSize={searchImageSize}
          onChange={searchImageSize => setCachablesState({ searchImageSize })}
        />
      </div>

      <InDeckCardGrid cardIds={Object.keys(multiSelectedIds)} />
    </GlobalOverlayStack>
  )
}

export default CardComparisonOverlay

type StandaloneCardGridOverlayProps = {
  open: boolean
  onClose: () => void
  cardIds: string[]
  header?: ReactNode
}

export const StandaloneCardGridOverlay = ({ open, onClose, cardIds, header }: StandaloneCardGridOverlayProps) => {
  const searchImageSize = useAppSelector(state => state.cacheables.searchImageSize)

  const [setCachablesState] = useActionless(SET_CACHEABLES_STATE)

  return (
    <GlobalOverlayStack className={styles.container} open={open} onClose={onClose}>
      <div className={styles.header}>
        <h2>{header || 'Related cards'}</h2>
        <ImageSizeControls
          className={styles.imageSizeControls}
          imageSize={searchImageSize}
          onChange={searchImageSize => setCachablesState({ searchImageSize })}
        />
      </div>

      <InDeckCardGrid cardIds={cardIds} />
    </GlobalOverlayStack>
  )
}
